import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

function AirportCharts({ data }) {
  // Get unique airports
  const airports = [...new Set(data.map((item) => item.Αεροδρόμιο))];

  // Sort and get unique years
  const uniqueYears = [...new Set(data.map((item) => item.Έτος))].sort();

  // Prepare data for chart
  const chartData = uniqueYears.map((year) => {
    const yearData = { Έτος: year };
    airports.forEach((airport) => {
      const filteredData = data.find(
        (item) => item.Έτος === year && item.Αεροδρόμιο === airport
      );
      if (filteredData) {
        yearData[airport] = parseFloat(filteredData["Τεχνική Αποδοτικότητα"]);
      }
    });
    return yearData;
  });

  const baseHue = 160; // Starting hue value for green (adjust as desired)
  const hueStep = 30; // Step value to adjust hue (adjust as desired)

  const getColorByIndex = (index) => {
    const hue = baseHue + index * hueStep;
    return `hsl(${hue}, 70%, 50%)`;
  };

  return (
    <div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="Έτος" />
          <YAxis />
          <Tooltip />
          <Legend />
          {airports.map((airport, index) => (
            <Bar
              key={airport}
              dataKey={airport}
              fill={getColorByIndex(index)}
              name={airport}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default AirportCharts;
